// src/components/Auth/AuthNavbar.js

import React from 'react';
import { NavLink } from 'react-router-dom'; // Use NavLink as per your requirement
import { useAuth } from "../../context/AuthContext"; // Import useAuth to access authentication state
import '../Navbar.css'; // Corrected import path to Navbar.css

const AuthNavbar = () => {
  const { currentUser } = useAuth(); // Access currentUser from AuthContext

  return (
    <nav className="navbar" aria-label="Authentication Navigation">
      <div className="navbar-links">
        {!currentUser ? (
          <>
            <NavLink 
              to="/login" 
              className={({ isActive }) => 
                isActive ? 'nav-link active-link' : 'nav-link'
              }
              end
            >
              Login
            </NavLink>
            <NavLink 
              to="/signup" 
              className={({ isActive }) => 
                isActive ? 'nav-link active-link' : 'nav-link'
              }
            >
              Sign Up
            </NavLink>
            <NavLink 
              to="/forgot-password" 
              className={({ isActive }) => 
                isActive ? 'nav-link active-link' : 'nav-link'
              }
            >
              Forgot Password
            </NavLink>
          </>
        ) : (
          <>
            <NavLink 
              to="/user-profile" 
              className={({ isActive }) => 
                isActive ? 'nav-link active-link' : 'nav-link'
              }
            >
              User Profile
            </NavLink>
          </>
        )}
      </div>
    </nav>
  );
};

export default AuthNavbar;


